export default "__VITE_ASSET__b18cc85c__"